import React from "react";
import {
  Users,
  Clock,
  CheckCircle,
  AlertCircle,
  ArrowUpRight,
} from "lucide-react";

const StatsGrid = ({ submissions = [] }) => {
  // Logic to calculate stats from data
  const total = submissions.length;
  const pending = submissions.filter((s) => s.status === "pending").length;
  const reviewed = submissions.filter((s) => s.status === "reviewed").length;
  const highPriority = submissions.filter((s) => s.priority === "high").length;

  const stats = [
    {
      label: "Total Applications",
      value: total,
      icon: Users,
      color: "text-blue-600",
      bg: "bg-blue-50",
    },
    {
      label: "Pending Review",
      value: pending,
      icon: Clock,
      color: "text-amber-600",
      bg: "bg-amber-50",
    },
    {
      label: "Reviewed",
      value: reviewed,
      icon: CheckCircle,
      color: "text-emerald-600",
      bg: "bg-emerald-50",
    },
    {
      label: "High Priority",
      value: highPriority,
      icon: AlertCircle,
      color: "text-red-600",
      bg: "bg-red-50",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {stats.map((stat, i) => (
        <div
          key={i}
          className="bg-white p-6 rounded-[2rem] border border-slate-100 shadow-sm hover:shadow-md transition-shadow group"
        >
          <div className="flex items-start justify-between">
            <div
              className={`p-3 rounded-2xl ${stat.bg} ${stat.color} transition-colors`}
            >
              <stat.icon size={24} />
            </div>
            <div className="flex items-center text-emerald-500 font-black text-xs">
              <ArrowUpRight size={14} className="mr-1" />
              12%
            </div>
          </div>
          <div className="mt-4">
            <h3 className="text-3xl font-black text-slate-900">{stat.value}</h3>
            <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mt-1">
              {stat.label}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsGrid;
